import * as XLSX from "xlsx-style";
import * as FileSaver from 'file-saver';

export function datenum(v, date1904) {
    if(date1904) v+=1462;
    const epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

export function resizeColumn(worksheet, lastColumn){
    let wscols = [];
    const width = {wch:20};
    for(let i = 0; i < lastColumn; ++i){
        wscols.push(width);
    }
    worksheet['!cols'] = wscols;
}

export function s2ab(s){
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (let i=0; i!==s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

export function format_sheet_summary(data){
    let ws = {};
    let range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
    const numberFmt = '#,##0';
    //const percentageFmt = '0.0%';
    for(let R = 0; R !== data.length; ++R) {
        for(let C = 0; C !== data[R].length; ++C) {
            if(range.s.r > R) range.s.r = R;
            if(range.s.c > C) range.s.c = C;
            if(range.e.r < R) range.e.r = R;
            if(range.e.c < C) range.e.c = C;
            let cell = {v: data[R][C] };
            if(cell.v == null) continue;
            let cell_ref = XLSX.utils.encode_cell({c:C,r:R});
            if(typeof cell.v === 'number') {cell.t = 'n';cell.z = numberFmt}
            else if(typeof cell.v === 'boolean') cell.t = 'b';
            else if(cell.v instanceof Date) {
                cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            }
            else cell.t = 's';
            //custom styles
            cell.s={
                font:{ name:"Arial" }
            }
            // Title
            if(R === 0){
                cell.s={
                    font:{ name:"Arial", bold:true,sz:"15"}
                }
            }
            // Description
            if(R === 1 || R === 2){
                cell.s={
                    font:{ name:"Arial", bold:true,sz:"12"}
                }
            }
            // Header
            if(R === 4){
                cell.s={
                    font:{ name:"Arial", bold:true, sz:"11" },
                    fill:{ fgColor:{ rgb: "FFFFAA00" } }
                }
            }
            //data content
            if(R > 4){
                cell.s={
                    font:{ name:"Arial", sz:"10"}
                }
            }
            // Summary row
            if(R === data.length - 1){
                cell.s={
                    font:{ name:"Arial", bold:true, sz:"11" }
                }
            }

            ws[cell_ref] = cell;
        }
    }
    if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    // column size
    let wscols = [];
    const width = {wch:20};
    wscols.push({wch:5});// first column
    for(let i = 0; i < 8; ++i){
        wscols.push(width);
    }
    ws['!cols'] = wscols;

    return ws;
}
export function format_sheet_detail(data){
    let ws = {};
    let range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
    const numberFmt = '#,##0';
    //const percentageFmt = '0.0%';
    for(let R = 0; R !== data.length; ++R) {
        for(let C = 0; C !== data[R].length; ++C) {
            if(range.s.r > R) range.s.r = R;
            if(range.s.c > C) range.s.c = C;
            if(range.e.r < R) range.e.r = R;
            if(range.e.c < C) range.e.c = C;
            let cell = {v: data[R][C] };
            if(cell.v == null) continue;
            let cell_ref = XLSX.utils.encode_cell({c:C,r:R});
            if(typeof cell.v === 'number') {cell.t = 'n';cell.z = numberFmt}
            else if(typeof cell.v === 'boolean') cell.t = 'b';
            else if(cell.v instanceof Date) {
                cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            }
            else cell.t = 's';
            //custom styles
            cell.s={
                font:{ name:"Arial" }
            }

            // Header
            if(R === 0){
                cell.s={
                    font:{ name:"Arial", bold:true, sz:"11" },
                    fill:{ fgColor:{ rgb: "FFFFAA00" } }
                }
            }
            //data content
            if(R > 0){
                cell.s={
                    font:{ name:"Arial", sz:"10"}
                }
            }
            ws[cell_ref] = cell;
        }
    }
    if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    // column size
    let wscols = [];
    const width = {wch:20};
    wscols.push({wch:5});// first column
    for(let i = 0; i < 39; ++i){
        wscols.push(width);
    }
    ws['!cols'] = wscols;

    return ws;
}
export function format_sheet_commission(data){
    let ws = {};
    let range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
    const numberFmt = '#,##0';
    //const percentageFmt = '0.0%';
    for(let R = 0; R !== data.length; ++R) {
        for(let C = 0; C !== data[R].length; ++C) {
            if(range.s.r > R) range.s.r = R;
            if(range.s.c > C) range.s.c = C;
            if(range.e.r < R) range.e.r = R;
            if(range.e.c < C) range.e.c = C;
            let cell = {v: data[R][C] };
            if(cell.v == null) continue;
            let cell_ref = XLSX.utils.encode_cell({c:C,r:R});
            if(typeof cell.v === 'number') {cell.t = 'n';cell.z = numberFmt}
            else if(typeof cell.v === 'boolean') cell.t = 'b';
            else if(cell.v instanceof Date) {
                cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            }
            else cell.t = 's';
            //custom styles
            cell.s={
                font:{ name:"Arial" }
            }
            // Title
            if(R === 1){
                cell.s={
                    font:{ name:"Arial", bold:true,sz:"15"}
                }
            }
            // Description
            if(R === 2){
                cell.s={
                    font:{ name:"Arial", bold:true,sz:"12"}
                }
            }
            // Header
            if(R === 4 && C !== 0){
                cell.s={
                    font:{ name:"Arial", bold:true, sz:"11" },
                    fill:{ fgColor:{ rgb: "FFFFAA00" } }
                }
            }
            //data content
            if(R > 4){
                cell.s={
                    font:{ name:"Arial", sz:"10"}
                }
            }

            // Summary row
            if(R === data.length - 4){
                cell.s={
                    font:{ name:"Arial", bold:true, sz:"13" }
                }
            }

            // last row
            if(R === data.length - 1){
                cell.s={
                    font:{ name:"Arial", bold:true, sz:"11" }
                }
            }

            ws[cell_ref] = cell;
        }
    }
    if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    // column size
    let wscols = [];
    const width = {wch:20};
    wscols.push({wch:5});
    wscols.push({wch:5});
    for(let i = 0; i < 7; ++i){
        wscols.push(width);
    }
    ws['!cols'] = wscols;

    return ws;
}
function LastDayOfMonth(Year, Month) {
    return new Date((new Date(Year, Month, 1)) - 1);
}
function formatDataSummary(item, data){
    const yearDisplay = item.paymentMonth.substring(0,4);
    const monthDisplay = item.paymentMonth.substring(4,6);
    const fromDateDisplay = '01'+'/'+monthDisplay+'/'+yearDisplay;
    const lastDayOfMonth = LastDayOfMonth(parseInt(yearDisplay), parseInt(monthDisplay));
    const toDateDisplay = lastDayOfMonth.getDate()+'/'+monthDisplay+'/'+yearDisplay;
    let dataSummary = [];
    dataSummary.push(["HOA HỒNG BẢO HIỂM ĐỐI TÁC - VCB"]);
    dataSummary.push(["Kỳ: "+item?.paymentMonth]);
    dataSummary.push(["Từ: "+fromDateDisplay+" - "+toDateDisplay]);
    dataSummary.push([""]);
    dataSummary.push(["STT"
        ,"Kỳ thanh toán"
        ,"Mã phòng giao dịch (FWD)"
        ,"Mã phòng giao dịch (VCB)"
        ,"Tên phòng giao dịch"
        ,"Kết quả xác nhận"
        ,"Mã sản phẩm"
        ,"Phí đóng bảo hiểm"
        ,"Hoa hồng thực nhận"
    ])
    let totalPremiumAmount = 0;
    let totalCommissionAmount = 0;
    data.map((item, index) =>{
            dataSummary.push([index + 1
                ,item?.paymentMonth
                ,item?.toCode
                ,item?.toCodeBank
                ,item?.toName
                ,item?.toConfirmStatus
                ,item?.productCode
                ,item?.premiumAmount
                ,item?.commissionAmount
            ])
            totalPremiumAmount = totalPremiumAmount +item?.premiumAmount
            totalCommissionAmount = totalCommissionAmount + item?.commissionAmount
        }
    )
    dataSummary.push([
         null
        ,"Tổng: "
        ,null
        ,null
        ,null
        ,null
        ,null
        ,totalPremiumAmount
        ,totalCommissionAmount
    ])
    return dataSummary;
}
function formatDataDetail(item, data){
    let dataDetail = [];
    dataDetail.push([
         "STT"
        ,"Kỳ thanh toán"
        ,"Số hợp đồng"
        ,"Ngày nộp"
        ,"Ngày phát hành"
        ,"Ngày phát hành lại"
        ,"Ngày ký nhận hợp đồng"
        ,"Sau 21 ngày ký nhận hợp đồng"
        ,"Tình trạng hợp đồng"
        ,"Ngày hủy"
        ,"Mã sản phẩm"
        ,"Tên sản phẩm"
        ,"Tên chủ hợp đồng"
        ,"CMND/ Passport"
        ,"Mã tư vấn"
        ,"Tên tư vấn"
        ,"Mã nhân viên giới thiệu (FWD)"
        ,"Mã nhân viên giới thiệu (VCB)"
        ,"Tên nhân viên giới thiệu"
        ,"Mã chi nhánh (FWD)"
        ,"Mã chi nhánh (VCB)"
        ,"Tên chi nhánh"
        ,"Mã phòng giao dịch (FWD)"
        ,"Mã phòng giao dịch (VCB)"
        ,"Tên phòng giao dịch"
        ,"Kết quả xác nhận"
        ,"Mã ngân hàng"
        ,"Tên ngân hàng"
        ,"Mệnh giá bảo hiểm"
        ,"Phí đóng bảo hiểm"
        ,"Năm hợp đồng"
        ,"Thời hạn đóng phí"
        ,"Tỷ lệ hoa hồng (%)"
        ,"Hoa hồng thực nhận"
        ,"Ghi chú"
        ,"Mã lãnh đạo phòng (HRM)"
        ,"Mã người giới thiệu (HRM Introduce)"
        ,"Số lượng sản phẩm bổ trợ"
        ,"Trạng thái của hợp đồng"
        ,"Hợp đồng DCL"
    ])
    data.map((item, index) =>{
        dataDetail.push([index + 1
            ,item?.paymentMonth
            ,item?.policyNumber
            ,item?.submitDate
            ,item?.issueDate
            ,item?.reIssueDate
            ,item?.ackDate
            ,item?.ackDate21
            ,item?.policyStatusName
            ,item?.cancelDate
            ,item?.productCode
            ,item?.productName
            ,item?.poName
            ,item?.poId
            ,item?.fscCode
            ,item?.fscName
            ,item?.bsCode
            ,item?.bsCodeBank
            ,item?.bsName
            ,item?.boCode
            ,item?.boCodeBank
            ,item?.boName
            ,item?.toCode
            ,item?.toCodeBank
            ,item?.toName
            ,item?.toConfirmStatus
            ,item?.bankCode
            ,item?.bankName
            ,item?.sa
            ,item?.premiumAmount
            ,item?.policyYear
            ,item?.premiumTerm
            ,item?.commissionRate
            ,item?.commissionAmount
            ,item?.notes
            ,item?.hrm
            ,item?.introducerHrm
            ,item?.riderCount
            ,item?.policyProductStatusCd
            ,item?.isDCL
        ])
        }
    )
    return dataDetail;
}
function formatDataCommission(item, data){
    const yearDisplay = item.paymentMonth.substring(0,4);
    const monthDisplay = item.paymentMonth.substring(4,6);
    const fromDateDisplay = 'THÁNG '+ monthDisplay+' NĂM '+yearDisplay;
    let dataComment = [];
    dataComment.push([null]);
    dataComment.push([null,"BẢNG KÊ THANH TOÁN HOA HỒNG ĐIỂM BÁN"]);
    dataComment.push([null,fromDateDisplay]);
    dataComment.push([null]);
    dataComment.push([
         null
        ,"STT"
        ,"Kỳ thanh toán"
        ,"Mã chi nhánh (VCB)"
        ,"Tên chi nhánh"
        ,"Mã phòng giao dịch (VCB)"
        ,"Tên phòng giao dịch"
        ,"Phí đóng bảo hiểm"
        ,"Hoa hồng thực nhận"
    ])
    let totalPremiumAmount = 0;
    let totalCommissionAmount = 0;
    data.map((item, index) =>{
            dataComment.push([
                 null
                ,index + 1
                ,item?.paymentMonth
                ,item?.boCodeBank
                ,item?.boName
                ,item?.toCodeBank
                ,item?.toName
                ,item?.premiumAmount
                ,item?.commissionAmount
            ])
            totalPremiumAmount = totalPremiumAmount + item?.premiumAmount
            totalCommissionAmount = totalCommissionAmount + item?.commissionAmount
        }
    )
    dataComment.push([null
        ,null
        ,"Tổng: "
        ,null
        ,null
        ,null
        ,null
        ,totalPremiumAmount
        ,totalCommissionAmount
    ])
    dataComment.push([null])
    dataComment.push([null])
    dataComment.push([
         null
        ,"NGƯỜI LẬP"
        ,null
        ,null
        ,null
        ,null
        ,null
        ,"LÃNH ĐẠO PHÒNG QLBSPBL"
        ,null
    ])
    return dataComment;
}

export function downloadExcelSummaryByBO(item, response, fileName){
    const sumarryArray = response[0].data?.reportSummaries;
    const commissionArray = response[1].data?.reportCommissions;
    const fileType = 'application/octet-stream';
    const fileExtension = '.xlsx';
    const dataSummary = formatDataSummary(item, sumarryArray);
    const summaryWorkSheet = format_sheet_summary(dataSummary);
    const dataCommission = formatDataCommission(item, commissionArray);
    const commissionWorkSheet = format_sheet_commission(dataCommission);
    const wb = { Sheets: { 'Tổng': summaryWorkSheet,'Chi trả hoa hồng':commissionWorkSheet}, SheetNames: ['Tổng','Chi trả hoa hồng'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', bookSST:false, type: 'binary', compression:true});
    const data = new Blob([s2ab(excelBuffer)], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
}

export function downloadExcelDetailByBO(item, response, fileName){
    const detailArray = response[0].data?.reportDetails;
        const fileType = 'application/octet-stream';
        const fileExtension = '.xlsx';
        const dataDetail = formatDataDetail(item, detailArray);
        const detailWorkSheet = format_sheet_detail(dataDetail);
        const wb = { Sheets: { 'Chi tiết': detailWorkSheet}, SheetNames: ['Chi tiết'] };
        console.log('before write:'+ new Date())
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', bookSST:false, type: 'binary', compression:true});
        console.log('end write:'+ new Date())
        const data = new Blob([s2ab(excelBuffer)], {type: fileType});
        console.log('before saveAs:'+ new Date())
        FileSaver.saveAs(data, fileName + fileExtension);
}

export default downloadExcelSummaryByBO;
